module.exports = __webpack_public_path__ + "img/pay-sdk-missing-payment.a133aed4.png";